import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { StateProvider } from "./state/Store";

import './proptypes/ArrayProptype'
import './proptypes/StringProptype'

import "./assets/css/html.css"
import "./assets/css/loader.css"
import "./assets/css/landingPage.css"
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import DashboardLayout from "layouts/DashboardLayout";

import { constants } from "utils/Constant";
import Search from "pages/landing/Search";


ReactDOM.render(
  <BrowserRouter>
    <StateProvider>
      <Switch>
        <Route path={constants.finalyze} render={(props) => <DashboardLayout {...props} />} />
        <Route path="/" render={(props) => <Search {...props} />} />
      </Switch>
    </StateProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
